(function ($) {
  "use strict";

  function isMobile() {
    return window.innerWidth <= 768;
  }

  Drupal.behaviors.topbarMenu = {
    attach: function (context) {
      $('.topbar-left', context).on('click', function () {
        if (isMobile()) {
          $(this).toggleClass('open');
        }
      });
    }
  };

  Drupal.behaviors.cotationsSlider = {
    attach: function (context) {
      $('.cotations-slider', context).slick({
        dots: true,
      });
    }
  };

  Drupal.behaviors.stickyBarBottom = {
    attach: function (context) {
      $(function () {
        var stickybar = $('.stickybar-footer', context);
        var link = stickybar.find('a').prop('href');
        stickybar.css('cursor', 'pointer');
        stickybar.on("click", function () {
          window.location = link;
        });
      });
    }
  }

  Drupal.behaviors.stickyBar = {
    attach: function (context) {
      $(function () {
        var body = $('body', context),
          sticky = $('.sticky'),
          stickyHeight = sticky.outerHeight(),
          stickyPadding = stickyHeight - 15;

        if ($(window).width() > 1200) {
          stickyPadding = 0;
        }

        $(window).scroll(function () {
          var scroll = $(window).scrollTop();

          if (scroll > 250 && $(window).width() >= 1024) {
            sticky.addClass('sticked');
            body.css('padding-top', stickyPadding);
          } else {
            sticky.removeClass('sticked');
            body.css('padding-top', 0);
          }
        });
      });
    }
  };

  Drupal.behaviors.font_resize = {
    attach: function (context) {
      var multiplier = 1.0;
      var step = 0.2;
      var selector = ".content-main .content-left article";
      var firefox = (navigator.userAgent.indexOf('Firefox') != -1 &&
        parseFloat(navigator.userAgent.substring(navigator.userAgent.indexOf('Firefox') + 8)) >= 3.6);

      if (!firefox) {
        $(selector).css('transition', 'transform .2s');
      }

      $(once('.font-size]', context)).bind('click', function () {
        multiplier = parseFloat((multiplier + step).toFixed(1));
        if (firefox) { //Firefox
          $(selector).css('height', 'auto');
          $(selector).css('width', (100 / multiplier) + '%');
          $(selector).css('MozTransform', 'scale(' + multiplier + ')');
          $(selector).css('-moz-transform-origin', 'top left');
          $(selector).css('height', $(selector)[0].getBoundingClientRect().height + 'px');
        }
        else {
          $(selector).css('zoom', multiplier);
        }

        if (multiplier >= (1 + (2 * step))) {
          multiplier = 1 - step;
        }

      });

    }
  };

  Drupal.behaviors.styles = {
    attach: function (context) {
      $('[data-style]', context).each(function () {
        $(this).attr('style', $(this).data('style'));
        $(this).removeAttr('data-style');
      });
    }
  };

})(jQuery);

(function ($, Drupal) {
  Drupal.behaviors.wrapElements = {
    attach: function (context) {
      var classNames = [
        "question",
        "sequence",
        "seqFleche",
        "seqNum",
        "encadre",
        "plusloin",
      ];
      for (var i in classNames) {
        do {
          needWrap = this.wrapElements($, classNames[i]);
        } while (needWrap);
      }
    },
    wrapElements: function ($, className) {
      return $("." + className)
        .first().prev()
        .nextUntil(":not(." + className + "):not(.embedded-entity):not(.lireaussi)")
        .removeClass(className)
        .wrapAll('<div class="' + className + '__wrapper" />').length;
    },
  };
}(jQuery, Drupal));
